var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenciledit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pencil edit alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 4.00043C18.5303 4.00043 19.0389 4.21106 19.414 4.586C19.7889 4.96106 19.9996 5.46967 19.9996 6C19.9996 6.53033 19.7889 7.03894 19.414 7.414L11.828 15H9V12.172L16.586 4.586C16.9611 4.21106 17.4697 4.00043 18 4.00043Z",
    fill: "#252C32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58579 6.58579C4.21071 6.96086 4 7.46957 4 8V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V14C18 13.7348 17.8946 13.4804 17.7071 13.2929C17.5196 13.1054 17.2652 13 17 13C16.7348 13 16.4804 13.1054 16.2929 13.2929C16.1054 13.4804 16 13.7348 16 14V18H6V8H10C10.2652 8 10.5196 7.89464 10.7071 7.70711C10.8946 7.51957 11 7.26522 11 7C11 6.73478 10.8946 6.48043 10.7071 6.29289C10.5196 6.10536 10.2652 6 10 6H6C5.46957 6 4.96086 6.21071 4.58579 6.58579Z",
    fill: "#252C32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenciledit);
export default __webpack_public_path__ + "static/media/penciledit.0d2b927273713c109dc2edd84ef5d8ee.svg";
export { ForwardRef as ReactComponent };